<template>
  <v-row dense no-gutters>
    <v-col cols="12" md="8" sm="12">
      <m-datepicker dense single-line outlined autofocus label="Tanggal" v-model="date" v-bind="$attrs"></m-datepicker>
    </v-col>
    <v-col cols="12" md="4" sm="12">
      <m-timepicker outlined dense :disabled="readonly" :min="minTime" v-model="time"></m-timepicker>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: () => null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: null,
      time: null,
    }
  },
  methods: {
    mutate() {
      this.$emit('input', this.date || this.time ? [this.date, this.time].join(' ') : '')
    },
    initValue() {
      if (this.value) {
        const date = this.value.split(' ')
        this.date = (date && date[0]) || null
        this.time = (date && date[1]) || null
      } else {
        this.date = null
        this.time = null
      }
    },
  },
  watch: {
    time: 'mutate',
    date: 'mutate',
    value: 'initValue',
  },
}
</script>
